import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import SectionLabel from '../ui/SectionLabel';
import { useSection } from '../../hooks/useSection';

const InvestCTA: React.FC = () => {
  const { section } = useSection('home_invest_cta');
  if (section && section.is_visible === false) return null;
  const ed = section?.extra_data || {};
  const eyebrow = section?.subtitle || 'Investir dans Proxy';
  const paragraph = section?.content || 'Motos, stations de recharge, financement, maintenance et formation : Proxy Emobility bâtit un écosystème complet. Investisseurs et partenaires, échangeons.';
  const btnLabel = section?.button_label || 'Manifester mon intérêt';
  const btnUrl = section?.button_url || '/invest';
  const cta2 = ed.cta_secondary || { label: 'Découvrir notre vision', link: '/invest#vision' };
  const trust = ed.trust || 'Opération accompagnée par un cabinet expert en fundraising';

  return (
    <section className="relative overflow-hidden bg-white py-14 sm:py-20 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-[2rem] bg-neutral-950 px-5 py-10 sm:px-10 sm:py-14 lg:px-16 lg:py-16">
          <div className="pointer-events-none absolute inset-0">
            <div className="absolute -top-32 left-[8%] h-80 w-80 rounded-full bg-primary-500/[0.18] blur-3xl" />
            <div className="absolute bottom-0 right-[6%] h-96 w-96 rounded-full bg-primary-600/[0.12] blur-3xl" />
          </div>
          <div className="relative mx-auto max-w-3xl text-center">
            <SectionLabel variant="dark" align="center" className="mb-5 justify-center">
              {eyebrow}
            </SectionLabel>
            <h2 className="mb-4 text-3xl font-black leading-[1.1] tracking-[-0.025em] text-white sm:text-4xl lg:text-5xl">
              {section?.title ? section.title : (<>Construisons l'infrastructure de la <span className="text-primary-400">mobilité électrique africaine</span></>)}
            </h2>
            <p className="mx-auto mb-8 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg">
              {paragraph}
            </p>
            <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to={btnUrl}
                className="group inline-flex w-full items-center justify-center gap-2 rounded-xl bg-white px-7 py-3.5 text-sm font-bold text-neutral-900 transition-all duration-300 hover:-translate-y-0.5 hover:bg-primary-400 sm:w-auto"
              >
                {btnLabel}
                <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </Link>
              <Link
                to={cta2.link || '/invest#vision'}
                className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-white/20 px-7 py-3.5 text-sm font-bold text-white transition-all duration-300 hover:bg-white/10 sm:w-auto"
              >
                {cta2.label || 'Découvrir notre vision'}
              </Link>
            </div>
            <div className="mt-7 inline-flex items-center gap-2 text-xs font-semibold text-white/50">
              <ShieldCheck size={14} className="text-primary-400" />
              {trust}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestCTA;
